import React from "react";
import { Breadcrumb } from "matx";
import { Card, Box, CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams } from "react-router-dom";

import UserForm from "./shared/UserForm";
import { getUserDetails, userSave } from "app/redux/actions/UserActions";

const UserEdit = () => {
  const [loading, setLoading] = React.useState(true);
  const [redirect, setRedirect] = React.useState(null);
  const { userDetails } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { id } = useParams();

  React.useEffect(() => {
    // console.log("DETAILS:", userDetails);
    if (userDetails && userDetails.id) {
      setLoading(false);
    }
  }, [userDetails]);

  React.useEffect(() => {
    dispatch(getUserDetails(id));
  }, [dispatch, id]);

  const submitUser = async (data) => {
    const user = await dispatch(userSave(data));
    // console.log("MM:", user);
    if (user.user && user.user.id) {
      setRedirect(`/users/list`);
    }
  };

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  if (loading) return <CircularProgress />;

  return (
    <div className="m-sm-30 menu">
      <div className="mb-sm-30 flex items-center justify-between">
        <Breadcrumb
          routeSegments={[
            { name: "Users", path: "/users/list" },
            { name: "Edit" },
          ]}
        />
      </div>
      <Box maxWidth={600}>
        <Card className="px-6 py-6">
          <UserForm
            onSave={(data) => submitUser(data)}
            initialData={userDetails}
          />
        </Card>
      </Box>
    </div>
  );
};
export default UserEdit;
